import ReactDOM from 'react-dom/client';
import { handleDeadSession } from '../../components/apia/main/TabsList/ContentRenderer';

window.closeSession = (dispatch = true) => handleDeadSession(dispatch);

export default function CreateIndex(BaseComponent: JSX.Element) {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );
  root.render(BaseComponent);
}
